import LoadingOverlay from '@components/loading-overlay';
import useLastMessages from '@hooks/xmpp/useLastMessages';
import React from 'react';
import NoPatients from './no-patients';
import Patient from './patient';
import PatientsTitle from './patients-title';
import { PatientsSC } from './patients.styled';

type TProps = {};

const Patients: React.FC<TProps> = ({}) => {
  const { inbox, isLoading } = useLastMessages();

  return (
    <PatientsSC>
      <PatientsTitle title="patients.your_patients" />
      <LoadingOverlay
        loading={isLoading}
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
      >
        {inbox.length > 0 ? (
          <div className="content-scrollable">
            {inbox.map((message) => {
              return <Patient item={message} key={message.patient.id} />;
            })}
          </div>
        ) : (
          <NoPatients />
        )}
      </LoadingOverlay>
    </PatientsSC>
  );
};

export default React.memo(Patients);
